import React from 'react';

/**
 * Uygulamanın en üst seviyesinde render hatalarını yakalar.
 * Herhangi bir bileşen render sırasında patlarsa kullanıcı beyaz ekran
 * yerine bu geri bildirim ekranını görür ve sayfayı yenileyebilir.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary] Beklenmedik render hatası:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            textAlign: "center",
            fontFamily: "inherit",
          }}
        >
          <h1 style={{ fontSize: "20px", fontWeight: 600, marginBottom: "8px" }}>
            Beklenmedik bir hata oluştu
          </h1>
          <p style={{ marginBottom: "16px", color: "#666" }}>
            Sayfayı yenileyerek tekrar deneyebilirsiniz.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: "10px 24px",
              borderRadius: "6px",
              border: "none",
              background: "#1f2937",
              color: "#fff",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Sayfayı Yenile
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
